// LXRA Marketplace Payouts & Revenue (Phase 5.5, simulated wallet — no processor)

export const ADMIN_EARNINGS = {
  tab: 'admin-tab-earnings',
  section: 'admin-earnings-section',
  available: 'admin-earnings-available',
  pending: 'admin-earnings-pending',
  lifetimeNet: 'admin-earnings-lifetime-net',
  lifetimeFee: 'admin-earnings-lifetime-fee',
  withdrawButton: 'admin-earnings-withdraw-button',
  payoutMethodForm: 'admin-earnings-payout-method-form',
  holderNameInput: 'admin-earnings-holder-name-input',
  bankNameInput: 'admin-earnings-bank-name-input',
  accountNumberInput: 'admin-earnings-account-number-input',
  routingNumberInput: 'admin-earnings-routing-number-input',
  savePayoutMethodButton: 'admin-earnings-save-payout-method-button',
  payoutHistory: 'admin-earnings-payout-history',
  payoutRow: (id) => `admin-earnings-payout-${id}`,
  empty: 'admin-earnings-empty',
};

export const ADMIN_REVENUE = {
  tab: 'admin-tab-revenue',
  section: 'admin-revenue-section',
  lifetimeFee: 'admin-revenue-lifetime-fee',
  monthFee: 'admin-revenue-month-fee',
  studioTable: 'admin-revenue-studio-table',
  studioRow: (id) => `admin-revenue-studio-row-${id}`,
  payoutsList: 'admin-revenue-payouts-list',
  empty: 'admin-revenue-empty',
};
